module.exports = __webpack_public_path__ + "img/t_guess.a9bd04ba.png";